import React from "react";
import { getFormattedNumber } from "../utils/textUtils";

const BelowReorderPoint = ({ resPacket, reportName, warehouse }) => {
  // Sort by CURRENT STOCK PACKED (descending — highest stock first)
  const sortedPacket = React.useMemo(
    () =>
      [...(resPacket || [])].sort(
        (a, b) =>
          (Number(b?.currentStockBoxQuantity) || 0) -
          (Number(a?.currentStockBoxQuantity) || 0)
      ),
    [resPacket]
  );

  return sortedPacket?.length > 0 ? (
    <div className="customTable"  id="scroll">
      <table className="customTable w-100">
        <thead className="fixed-thead">
          <tr>
            <td>SNO.</td>
            <td>ITEM</td>
            {/* <td>ITEM CATEGORY</td>
                    <td>ITEM SUB CATEGORY</td> */}
            <td>REORDER POINT</td>
            <td>REORDER POINT UNIT</td>
            {/* <td>Item Weight Quantity</td> */}
            <td>CURRENT STOCK PACKED</td>
            <td>CURRENT STOCK PACKED UNIt</td>
            {/* <td>CURRENT STOCK LOOSE</td>
            <td>CURRENT STOCK LOOSE UNIT</td>
            <td>TOTAL AVAILABLE STOCK</td>
            <td>TOTAL AVAILABLE STOCK UNIT</td> */}
          </tr>
        </thead>
        <tbody className="body-scroll-custom">
          {sortedPacket.map((a, i) => (
            <tr key={i}>
              <td>{i + 1}</td>
              <td>{a.itemTitle}</td>
              {/* <td>{a.category}</td>
                        <td>{a.subCategory}</td> */}
              <td>{getFormattedNumber(a.reorderPoint)}</td>
              <td>{a.packUnitTitle}</td>
              {/* <td>
                            {getFormattedNumber(a.itemWeightQuantity)} {a.weightUnitTitle}
                        </td> */}

              <td>
                {getFormattedNumber(a.currentStockBoxQuantity)}
                {/* &nbsp;{a.packUnitTitle} */}
              </td>
              <td>{a.packUnitTitle}</td>
              {/* <td>
                {getFormattedNumber(a.currentStockOpenQuantity)}
              </td>
              <td>
                {reportName === "Below ReOrder Point"
                  ? a.weightUnitTitle
                  : a.itemUnitTitle}
              </td>
              <td style={{ color: a.totalQuantity < 0 ? "red" : "black" }}>
                {getFormattedNumber(a.totalQuantity)}
              </td>
              <td>{a.weightUnitTitle}</td> */}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  ) : (
    <>No Record found</>
  );
};

export default BelowReorderPoint;
